export const messages = {
  en: {
    integralDetail: {
      all: 'All',
      personal: 'Personal',
      merchant: 'Merchant',
      queryCondition: 'Query Conditions',
      accountPlaceholder: 'Please enter account',
      typePlaceholder: 'Please select type',
      objTypePlaceholder: 'Please select object type',
      orderIdPlaceholder: 'Please enter transaction number',
      query: 'Query',
      integralTransaction: 'Integral Transaction',
      id: 'ID',
      accountName: 'Account Name',
      accountId: 'Account ID',
      type: 'Type',
      transferIn: 'Transfer In',
      transferOut: 'Transfer Out',
      relatedAccount: 'Related Account',
      points: 'Points',
      objType: 'Object Type',
      user: 'User',
      objId: 'Object ID',
      phone: 'Phone',
      orderNo: 'Order No',
      transactionTime: 'Transaction Time',
      remark: 'Remark'
    }
  },
  zh: {
    integralDetail: {
      all: '全部',
      personal: '个人',
      merchant: '商户',
      queryCondition: '查询条件',
      accountPlaceholder: '请填写账户',
      typePlaceholder: '请选择类型',
      objTypePlaceholder: '请选择对象类型',
      orderIdPlaceholder: '请选择交易单号',
      query: '查询',
      integralTransaction: '积分交易',
      id: '编号',
      accountName: '账户名称',
      accountId: '账户编号',
      type: '类型',
      transferIn: '转入',
      transferOut: '转出',
      relatedAccount: '关联账户',
      points: '积分数',
      objType: '对象类型',
      user: '用户',
      objId: '对象ID',
      phone: '手机号',
      orderNo: '交易单号',
      transactionTime: '交易时间',
      remark: '备注'
    }
  }
}